/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

export type GetDueCollectionsByDateRangeStatus = typeof GetDueCollectionsByDateRangeStatus[keyof typeof GetDueCollectionsByDateRangeStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDueCollectionsByDateRangeStatus = {
  Due_Today: 'Due Today',
  Due_Soon: 'Due Soon',
  Partially_Paid: 'Partially Paid',
} as const;
